var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoupeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.991,
    height: 48.991,
    viewBox: "0 0 48.991 48.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00b9ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.574,0A21.574,21.574,0,1,0,43.149,21.574,21.6,21.6,0,0,0,21.574,0Zm0,39.166A17.592,17.592,0,1,1,39.166,21.574,17.612,17.612,0,0,1,21.574,39.166Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.59 33.59)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M365.863,363.047l-11.418-11.418a1.991,1.991,0,0,0-2.816,2.816l11.418,11.418a1.991,1.991,0,0,0,2.816-2.816Z",
    transform: "translate(-351.046 -351.046)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupeIcon);
export default __webpack_public_path__ + "static/media/loupe-icon.c855036c9bd8a9cfe7aab0b004856a69.svg";
export { ForwardRef as ReactComponent };